import { isUploadcareUrl, Transformation, uuidToUrl } from 'main/util/uploadcare'
import * as React from 'react'
import SrcSmartImage from './SrcSmartImage'
import UploadcareSmartImage from './UploadcareSmartImage'

interface IProps {
  uuid?: string
  src?: string
  srcSet?: string
  height?: number
  width?: number
  // set to true if the resouce is a svg
  svg: boolean
  // set to true if the resource should not be lazy loaded
  critical: boolean
  // set to true if the component is being rendered in an overflow container
  // maps to https://github.com/twobin/react-lazyload#overflow
  overflow: boolean
  uploadcareTransformations?: Transformation[]
}

export default function SmartImage(props: IProps) {
  const { uuid, src, svg, uploadcareTransformations, ...rest } = props
  const uploadcareUrl = resolveUploadcareUrl(uuid, src)

  // if it's an uploadcare url and the asset is not a svg, take uploadcare branch as it'll
  // apply smart transformations to load the optimal variant
  if (uploadcareUrl !== undefined && !svg) {
    return (
      <UploadcareSmartImage
        src={uploadcareUrl}
        baseTransformations={uploadcareTransformations}
        {...rest}
      />
    )
  }

  // if it's an uploadcare url and the asset is a svg, perform no transformations and load as is
  if (uploadcareUrl !== undefined) return <SrcSmartImage src={uploadcareUrl} {...rest} />
  // if it's not uploadcare url, it as is
  if (src !== undefined) return <SrcSmartImage src={src} {...rest} />

  throw new Error('uuid or src required')
}

SmartImage.defaultProps = {
  critical: false,
  overflow: false,
  svg: false,
}

function resolveUploadcareUrl(uuid?: string, src?: string) {
  if (uuid !== undefined) return uuidToUrl(uuid)
  if (src !== undefined && isUploadcareUrl(src)) return src
}
